import { render, staticRenderFns } from "./ItensContrato.vue?vue&type=template&id=66b4dba0"
import script from "./ItensContrato.vue?vue&type=script&lang=js"
export * from "./ItensContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports